export enum CheckinType {
  QR_CODE = 'QR_CODE',
  LOCATION = 'LOCATION',
  BOTH = 'BOTH',
}
